import { observable, action } from 'mobx';
import { globalStore } from './global';
import { formatDateTime } from '../../js/utils';
import { updateParkingspaceState } from '../../service';
import { readStore } from './rf';

export default class GeoStore {
  // 地磁检测计算数值集合
  @observable detect = {
    stat: {
      name: '检测状态（有车/无车）',
      desc: '',
      value: null
    },
    eval: {
      name: '有车估值',
      desc: '',
      value: null
    },
    fsda2: {
      name: '方差值',
      desc: '',
      value: null
    },
    radar: {
      name: '雷达值',
      desc: '',
      value: null
    },
    xyzt: {
      name: '检测值',
      desc: '',
      value: null
    },
    base: {
      name: '浮动基值',
      desc: '',
      value: null
    },
    diff: {
      name: '差值',
      desc: '',
      value: null
    },
    feval: {
      name: 'feval',
      desc: '',
      value: null
    },
    feval_prev: {
      name: 'feval_prev',
      desc: '',
      value: null
    },
    aeval: {
      name: 'aeval',
      desc: '',
      value: null
    },
    aeval_prev: {
      name: 'aeval_prev',
      desc: '',
      value: null
    },
    fbase: {
      name: 'fbase',
      desc: '',
      value: null
    },
    abase: {
      name: 'abase',
      desc: '',
      value: null
    }
  };

  // eslint-disable-next-line camelcase
  @observable g_v2 = [];

  // 雷达基值
  @observable radarBase = [];

  // 地磁检测状态
  @observable state = null;

  // 地磁检测状态变化时间
  @observable changeTime = null;

  // 地磁初始状态是否变化，如果初始值获取为无车，changed不改变
  // 主要用于首次检测为无车时不播放音效，后期的检测变化为无车时才播放音效
  @observable changed = false;

  // 当前地磁信道
  @observable channel = null;

  @observable radarResult = {
    name: '雷达检测结果',
    value: null
  }

  @action setDetect(key, value) {
    this.detect[key].value = value;
  }

  @action setState(data) {
    const result = data.toString().replace('parking status changed: ', '')
      .replace(/\r\n/g, '')
      .replace('[log]', '')
      .replace(/\s/g, '');
    const value = result.split(',');
    // const time = +new Date('2018/01/01 00:00:00') + parseInt(value[1], 10) * 1000;

    // alg3 output 会在changed输出之前，导致状态其实已经变化，所以需要在return之前确保快速检测生效
    if (globalStore.quickDetect && data.toString().indexOf('parking status changed: ') !== -1) {
      updateParkingspaceState({
        serial: readStore.RFID,
        state: value[0],
        time: value[1]
      });
    }

    const state = parseInt(value[0], 10) ? '有车' : '无车';
    if (this.state === state) return;

    const time = new Date();
    this.changeTime = formatDateTime(new Date(time));
    if (this.state !== null) {
      this.changed = true;
    }
    this.state = state;
  }

  @action setRadarBase(value) {
    this.radarBase = value.map(item => Number(item));
  }

  @action setDetectValue(data) {
    const temp = data.match(/\((.*)?\)/)[1];
    const result = temp.replace(/(\[|\])/g, '').split(', ');
    console.log(`检测值: ${result}`);

    // 正常情况下，alg3 output会输出多次，最终检测结果以parking status changed: 为准，防止丢包，所以将这种检测值添加
    this.setDetect('stat', parseInt(result[0], 10) ? '有车' : '无车');
    this.setState(result[0]);

    if (result.length > 19) {
      return;
    }

    if (result.length > 15) {
      this.setDetect('feval', result[1]);
      this.setDetect('feval_prev', result[2]);
      this.setDetect('aeval', result[3]);
      this.setDetect('aeval_prev', result[4]);
      this.setDetect('fsda2', result[5]);
      this.setDetect('radar', result[6]);
      this.setDetect('xyzt', result.slice(7, 11).join(','));
      this.setDetect('fbase', result.slice(11, 15).join(','));
      this.setDetect('abase', result.slice(15).join(','));
    } else {
      this.setDetect('eval', result[1]);
      this.setDetect('fsda2', result[2]);
      this.setDetect('radar', result[3]);
      this.setDetect('xyzt', result.slice(4, 8).join(','));
      this.setDetect('base', result.slice(8, 12).join(','));
      this.setDetect('diff', result.slice(12).join(','));
    }
  }

  @action setGv2(data) {
    const index = data.match(/\[(\d+)\]/)[1];
    this.g_v2[parseInt(index, 10)] = data.replace(/.*\[.*\]\s+/, '');
  }

  @action setRadarDetect(data) {
    this.radarResult.value = data.replace(/\[log\]/, '')
      .replace(/\r\n/g, '');
  }

  @action reset() {
    this.state = null;
    this.changeTime = null;
    this.changed = false;
    this.g_v2 = [];
    this.radarBase = [];
    this.radarResult = {
      name: '雷达检测结果',
      value: null
    };
  }
}

export const geoStore = new GeoStore();
